<!-- 搜索 -->
<template>
  <div class="search">
    <div class="search-box">
      <!-- 搜索框 -->
      <van-search
        v-model="keyword"
        :placeholder="tab?'请输入搜索公司名称':'请输入搜索职位关键词'"
        @search="onSearch"
        show-action
        @cancel="cancel"
      />
      <!-- 搜索结果 -->
      <!-- 筛选 -->
    </div>
    <!-- 历史记录 -->
    <div class="history" v-show="!history">
      <div class="history-box">
        <p class="history-title">历史搜索</p>
        <img src="@/assets/img/home/del.png" class="del-img" @click="delteHistory" />
      </div>
      <p class="roced" v-if="arrList.length==0">您还没有{{arrList.length==0?'历史':'搜索'}}记录！</p>
      <!-- 历史记录内容 -->
      <div class="history-content">
        <div
          class="history-item"
          v-for="(item, index) in arrList"
          :key="index"
          @click="fastTap(item)"
        >{{item}}</div>
      </div>
    </div>
    <div class="home-tuijian" v-show="history">
      <p class="home-text">搜索结果</p>
      <!-- <div class="home-address">
        <div :class="{'home-items':true,' actived':selectInfos.length>0}" @click="nav(1)">
          <span
            :class="{'actived':selectInfos.length>0}"
          >{{selectInfos.length==0?'地点':selectInfos[0]}}</span>
          <img
            :src="selectInfos.length==0?require('@/assets/img/home/selectDown.png'):require('@/assets/img/home/selected.png')"
          />
        </div>
        <div :class="{'home-items':true,' actived':selectNums!=''}" @click="nav(2)">
          <span :class="{'actived':selectNums!=''}">{{selectNums==''?'筛选':'筛选·'+selectNums}}</span>
          <img
            :src="selectNums==''?require('@/assets/img/home/selectDown.png'):require('@/assets/img/home/selected.png')"
          />
        </div>
      </div>-->
    </div>
    <!-- 列表项 -->
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      :immediate-check="false"
      v-show="history"
    >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-if="!tab">
          <div
            class="list"
            v-for="(item, index) in positionList"
            :key="index"
            @click="goDetails(item.job_id)"
          >
            <div class="list-item">
              <span class="list-title">{{item.job_name}}</span>
              <span class="list-price">{{item.min_salary}}-{{item.max_salary}}</span>
            </div>
            <div class="list-item">
              <span class="list-request">{{item.district_name}}</span>
              <span class="list-request">{{item.experience==0?'不限':item.experience}}</span>
              <span class="list-request">{{item.education==0?'不限':item.education}}</span>
              <span class="list-request">{{item.amount==0?'不限':`招${item.amount}人`}}</span>
            </div>
            <div class="list-item">
              {{item.tag.length==0?'还没有添加福利哦~':''}}
              <span
                class="list-welfare"
                v-for="(i, idx) in item.tag"
                :key="idx"
              >{{i}}</span>
            </div>
            <div class="list-item">
              <img :src="item.company_logo" class="list-logo" />
              <span class="list-name">{{item.company_name}}</span>
              <button
                :class="{'list-btn':true,'applied':item.is_apply==1?true:false}"
              >{{item.is_apply==0?'申请':'已申请'}}</button>
            </div>
          </div>
        </div>
        <div v-if="tab">
          <!-- 推荐企业 -->
          <div
            class="company-list"
            v-for="(item, index) in positionList"
            :key="index"
            @click="navDetails(item.company_id)"
          >
            <img class="company-img" :src="item.logo" />
            <div class="company-box">
              <span class="name">{{item.name}}</span>
              <div class="icon">
                <span class="item">{{item.address}} ∣ {{item.nature_name}} ∣ {{item.trade_name}}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getPositionList, companyQuery } from "@/api/apiData";
import { setStorage, getStorage, removeStorage } from "@/until/localStorage";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      keyword: "",
      history: false,
      page: 0,
      totalPages: 1,
      positionList: [],
      offset: 10,
      loading: false,
      finished: false,
      refreshing: false,
      arrList: [],
      tab: ""
    };
  },
  computed: {
    ...mapState(["lists", "token", "selectNums", "selectInfos", "searchArray"])
  },
  methods: {
    ...mapMutations(["userSearch", "selectNum", "selectAddress", "select"]),
    //   搜索监听
    onSearch(val) {
      // 设置搜索历史
      var that = this;
      var arrList = that.arrList;
      var keyword = that.keyword;
      if (that.keyword.length == 0) {
        Toast("请输入搜索内容！");
      } else {
        that.totalPages = 1;
        that.page = 0;
        that.positionList = [];
        if (typeof arrList == "string") {
          arrList = [];
        }
        arrList.push(keyword);
        that.arrList = [...new Set(arrList)];
        setStorage("list", that.arrList);
        that.getList();
      }
    },
    // 查看公司详情
    navDetails(id) {
      const that = this;
      that.$router.push({
        name: "ComponyDetails",
        query: {
          id: id
        }
      });
    },
    // 前往职位详情
    goDetails(id) {
      var that = this;
      that.$router.push({
        name: "positionDetails",
        query: {
          id: id
        }
      });
    },
    // 快捷搜索
    fastTap(val) {
      var that = this;
      that.keyword = val;
      that.onSearch();
    },
    // 删除历史记录
    delteHistory() {
      var that = this;
      removeStorage("list");
      that.arrList = [];
    },
    // 路由跳转
    nav(val) {
      var that = this;
      if (val == 1) {
        // 地点
        that.$router.push({
          path: "./address",
          query: {
            history: that.history,
            entrance: "1"
          }
        });
      } else {
        //筛选
        that.$router.push({
          path: "./screen",
          query: {
            history: that.history,
            entrance: "1"
          }
        });
      }
    },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.selectNum("");
      if (that.selectInfos.length > 0) {
        that.selectAddress(["", "", 1, "type"]);
      }
      that.page = 0;
      that.positionList = [];
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    },
    // 取消
    cancel() {
      const that = this;
      that.selectNum("");
      if (that.selectInfos.length > 0) {
        that.selectAddress(["", "", 1, "type"]);
      }
      that.userSearch([]);
      this.$router.back();
    },
    // 获取职位列表
    getList() {
      var that = this;
      let {
        page,
        totalPages,
        positionList,
        offset,
        selectInfos,
        lists,
        keyword,
        tab
      } = that;

      if (tab) {
        let obj = {
          keyword: keyword
        };
        if (totalPages > page) {
          that.loading = true;
          companyQuery(obj).then(res => {
            // //(res);
            if (res.code == 1) {
              that.positionList = positionList.concat(res.data.data);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              if (res.data.data.length == 0) {
                if (that.positionList.length == 0) {
                  Toast("对不起，没有找到您搜索的内容哦~");
                }
                setTimeout(() => {
                  that.loading = false;
                  that.finished = true;
                }, 1500);
                return false;
              }
              if (that.positionList.length > positionList.length) {
                that.history = true;
                that.userSearch([that.keyword, that.history]);
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            }
          });
        } else {
          that.finished = true;
          that.loading = false;
        }
      } else {
        let obj = {
          page: page + 1,
          offset: offset,
          keyword: keyword,
          district: selectInfos.length > 0 ? selectInfos[1] : "",
          education: lists.length > 0 ? lists[0] : "",
          experience: lists.length > 0 ? lists[2] : "",
          min_salary:
            lists.length > 0 ? (lists[1].length > 0 ? lists[1][0] : "") : "",
          max_salary:
            lists.length > 0 ? (lists[1].length > 0 ? lists[1][1] : "") : ""
        };
        if (totalPages > page) {
          that.loading = true;
          getPositionList(obj).then(res => {
            // //(res);
            if (res.code == 1) {
              that.positionList = positionList.concat(res.data.list);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              if (res.data.list.length == 0) {
                if (that.positionList.length == 0) {
                  Toast("对不起，没有找到您搜索的内容哦~");
                }
                setTimeout(() => {
                  that.loading = false;
                  that.finished = true;
                }, 1500);
                return false;
              }
              if (that.positionList.length > positionList.length) {
                that.history = true;
                that.userSearch([that.keyword, that.history]);
                setTimeout(() => {
                  that.loading = false;
                }, 1500);
              }
            }
          });
        } else {
          that.finished = true;
          that.loading = false;
        }
      }
    }
  },
  created() {
    if (getStorage("list")) {
      this.arrList = getStorage("list").split(",");
    }
    this.keyword = this.searchArray.length > 0 ? this.searchArray[0] : "";
    this.history = this.searchArray.length > 0 ? this.searchArray[1] : "";
    this.tab = this.$route.query.type;
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
/deep/.van-search {
  padding: 0.18rem 0.32rem;
}
/deep/.van-search__action {
  font-size: 0.28rem;
  color: #666666;
}

.search {
  background: #f0f2f5;
  .search-box {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    // 职位推荐
  }
  .home-tuijian {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(50, 50, 50, 1);
    // margin-top: 0.18rem;
    padding: 0.15rem 0.32rem;
    background: #fff;
    .home-text {
      font-size: 0.3rem;
      font-weight: 600;
      line-height: 0.42rem;
      text-align: left;
      flex: 1;
      display: flex;
      align-items: center;
    }
    .home-text::before {
      content: "";
      display: block;
      width: 0.06rem;
      height: 0.24rem;
      background: #ff4343;
      margin-right: 0.1rem;
    }
    .home-address {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .home-items {
        display: flex;
        align-items: center;
        padding: 0.08rem 0.15rem;
        background: rgba(247, 247, 247, 1);
        border-radius: 0.04rem;
        margin: 0 0.1rem;
        flex-wrap: wrap;
        span {
          font-size: 0.24rem;
          font-weight: 400;
          color: rgba(112, 112, 112, 1);
        }
        img {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
      .actived {
        color: #ff4343 !important;
        background: rgba(255, 238, 238, 1);
      }
    }
  }
  .history {
    padding: 0.3rem 0.32rem;
    border-top: 0.01rem solid rgba(0, 0, 0, 0.08);
    background: #fff;

    .history-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.1rem;
      .history-title {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 0.45rem;
        color: rgba(51, 51, 51, 1);
      }
      .del-img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
    .roced {
      color: rgba(178, 178, 178, 0.5);
      font-size: 0.3rem;
      text-align: center;
      padding-top: 1rem;
    }
    .history-content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      max-height: 2.4rem;
      overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      .history-item {
        margin: 0.1rem 0.2rem 0.1rem 0;
        background: rgba(248, 248, 248, 1);
        padding: 0 0.26rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        max-width: 3rem;
        line-height: 2.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        border-radius: 0.08rem;
      }
    }
  }
  //   列表项
  // .history::before{
  //   content: "";
  //   display: block;
  //   width: 100%;
  //   // background: red;
  //   height: 1rem;
  // }
  .list {
    background: #fff;
    padding: 0.24rem 0.32rem;
    margin-top: 0.2rem;
    .list-item {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: relative;
      font-size: 0.24rem;
      color: rgba(77, 77, 77, 1);
      .list-title {
        display: flex;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(50, 50, 50, 1);
      }
      .list-price {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(255, 67, 67, 1);
        justify-items: flex-end;
      }
      .list-request {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
      }
      .list-welfare {
        padding: 0.06rem 0.1rem;
        background: rgba(248, 248, 248, 1);
        border-radius: 0.04rem;
        color: rgba(77, 77, 77, 1);
        font-size: 0.24rem;
        margin-right: 0.16rem;
      }
      .list-btn {
        padding: 0.09rem 0.32rem !important;
        line-height: 0.33rem;
        font-size: 0.24rem;
        color: rgba(255, 255, 255, 1);
        background: #ff4343;
        border-radius: 0.04rem;
        position: absolute;
        right: 0;
      }
      // 已申请
      .applied {
        background: rgba(204, 204, 204, 1);
      }
      .list-logo {
        width: 0.36rem;
        height: 0.36rem;
        margin-right: 0.1rem;
      }
      .list-name {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .list-request::after {
        content: "";
        display: block;
        width: 0.02rem;
        height: 0.2rem;
        background: #4d4d4d;
        margin: 0 0.2rem;
      }
      .list-request:last-child::after {
        display: none;
      }
    }
    .list-item:nth-child(1) {
      justify-content: space-between;
    }
    .list-item:nth-child(2),
    .list-item:nth-child(4) {
      padding: 0.16rem 0;
    }
  }
  .list:first-child {
    margin-top: 0;
  }
  // 搜索企业
  .company-list {
    background: #fff;
    padding: 0.24rem 0.32rem;
    margin-top: 0.2rem;
    font-size: 0.3rem;
    display: flex;
    .company-img {
      width: 1.2rem;
      height: 1.2rem;
    }
    .company-box {
      margin-left: 0.3rem;
      position: relative;
      width: 80%;
      .name {
        font-size: 0.34rem;
        font-weight: bold;
        line-height: 1.5;
        color: #333333;
        display: block;
        margin-bottom: 0.14rem;
      }
      .icon {
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        color: #8f8f8f;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
.search::before {
  content: "";
  width: 100%;
  height: 1rem;
  display: block;
  background: red;
}
</style>